import { render } from "./OrganizationItem.vue?vue&type=template&id=0406ba14&scoped=true"
import script from "./OrganizationItem.vue?vue&type=script&lang=js"
export * from "./OrganizationItem.vue?vue&type=script&lang=js"

import "./OrganizationItem.vue?vue&type=style&index=0&id=0406ba14&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0406ba14"]])

export default __exports__